var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"modal-header\"\u003E\u003Ch3 class=\"modal-title\" data-bind=\"text: title\"\u003E\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;